<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-combobox
        :item-value="itemValue"
        :item-text="itemText"
        :items="filterItems"
        :value="current"
        :error-messages="errors"
        :label="label"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        :search-input.sync="search"
        return-object
        eager
        :hide-details="hideDetails"
        :dense="dense"
        @change="change">
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      itemValue: {
        type: String,
        default: 'key'
      },
      itemText: {
        type: String,
        default: 'value'
      },
      hideDetails: {
        type: [String, Boolean],
        default: null
      },
      value: {
        type: [String, Number],
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        require: true,
        default: () => {
          return []
        }
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        isLoading: false,
        search: ''
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      },
      current () {
        const vm = this
        return vm.items.find(u => u[this.itemValue] === vm.value)
      },
      filterItems () {
        let items = this.items
        if (this.search && (!this.current || this.search !== this.current[this.itemText])) {
          items = items.filter(p => p[this.itemText].includes(this.search))
        }
        if (this.current && this.current[this.itemValue]) {
          items = items.filter(p => this.current[this.itemValue] !== p[this.itemValue])
        }
        return items
      }
    },
    methods: {
      change: function (item) {
        this.$emit('input', item ? item[this.itemValue] : null)
        this.$emit('change', item)
      }
    }
  }
</script>
